module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-10.8a8d9a23.png";